// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"585":"69df39ad","832":"93ff4495"}[chunkId] + ".chunk.js";
};